import { useState } from 'react';
import I18n from 'i18n-js';
import { bool, func, shape, string } from 'prop-types';

import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body from '~/components/DailyTasksView/DailyRewardPopupsBody';
import Footer from '~/components/DailyTasksView/DailyTiles/Tile/DailyRewardPopup/Footer';

export default function DailyRewardPopup({
  popupGradient,
  reward,
  show,
  toggleShow,
  ...props
}) {
  const { image, title, active, next, collected, src, element, description } =
    reward || {};

  const [receivedReward, setReceivedReward] = useState(false);

  const processDescription = () => {
    if (receivedReward) {
      return I18n.t('DailyView_popup_reward_received');
    }

    if (element) {
      return element;
    }

    return description;
  };

  return (
    <>
      <BottomPopupWithTransition
        banner={I18n.t('DailyView_bc')}
        closeButtonEnabled={!active || next}
        body={
          <Body
            description={processDescription()}
            image={{
              alt: title,
              src,
              image,
              collected,
            }}
            title={title}
          />
        }
        footer={
          <Footer
            receivedReward={receivedReward}
            setReceivedReward={setReceivedReward}
            popupGradient={popupGradient}
            reward={reward}
            {...props}
          />
        }
        onClose={toggleShow}
        show={show}
        style={{ background: `linear-gradient(${popupGradient})` }}
      />
    </>
  );
}

DailyRewardPopup.propTypes = {
  lastClaimAt: string,
  dailyNotificationsEnabled: bool.isRequired,
  siteNotificationsEnabled: bool.isRequired,
  popupGradient: string,
  reward: shape({
    image: string,
    src: string,
    title: string,
    active: bool,
    next: bool,
    collected: bool,
  }),
  show: bool.isRequired,
  toggleShow: func.isRequired,
};
